import {
	Component,
	ViewEncapsulation,
	OnInit,
	Inject,
	ViewChild,
	ElementRef,
	TemplateRef,
} from '@angular/core';
import { getFirebaseBackend } from '../../../app/authUtils';
import { User } from '../../core/models/user';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OldDataService } from 'src/app/core/services/old-data.service';
// import { AppConfig, APP_CONFIG } from "app/app-config.module";
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2';
import {
	Client,
	Contract,
	ContractsCampaigns,
	CustomerType,
	Order,
} from '../../core/models/client';
import { Md5 } from 'ts-md5';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContractsService } from '../../services/contracts/contracts.service';
import { OrdersService } from '../../services/orders/orders.service';
import * as dayjs from 'dayjs';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { AuthfakeauthenticationService } from 'src/app/core/services/authfake.service';
import { UserService } from 'src/app/services/user/user.service';
import { data } from 'jquery';
import { CampaignService } from 'src/app/services/campaigns/campaign.service';
import { UtilsEndPoints } from 'src/app/services/UtilsEndPoints/utilsEndPoints.service';
import { INDUSTRIES } from 'src/app/shared/constants';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { UserWizardComponent } from '../../shared/wizards/user-wizard/user-wizard.component';
import { ContractWizardComponent } from '../../shared/wizards/contract-wizard/contract-wizard.component';
import { CampaignWizardComponent } from 'src/app/shared/wizards/campaign-wizard/campaign-wizard.component';
import { EditClientComponent } from './edit-client/edit-client.component';
import { Router } from '@angular/router';

@Component({
	selector: 'app-client-users',
	templateUrl: './client-users.component.html',
	styleUrls: ['./client-users.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ClientUsersComponent implements OnInit {
	@ViewChild(DatatableComponent) table: DatatableComponent

	@ViewChild('alias') alias: ElementRef;
	@ViewChild('Login') login: ElementRef;
	@ViewChild('company') company: ElementRef;
	@ViewChild('prospect') prospect: ElementRef;
	@ViewChild('campaign') campaign: ElementRef;




	user: User;
	loading = false;

	temp = [];

	usersMsg: string = '';
	columnMode = ColumnMode;
	showPass: number = -1;
	filterClient: string = '';
	SearchFilters: any = [];
	public employeeUsers: any = [];
	activeTab = 1;
	client_id: number = 0;
	customer_id: number = 0;
	contract_id: number = 0;
	campaign_contractid: number = 0;
	order_id: number = 0;
	campaigns: any = [];
	types: any = [];
	typesSelected: any = [];
	industries = INDUSTRIES;
	name_customer = '';
	list_documents: any = [];
	files: any;
	loading_docs = false;
	loading_orders = false;
	appearDateTime: boolean = false;
	date_saved_order: dayjs.Dayjs;
	type_orderid = 0;

	updateContract = false;
	contractLoading = false;
	emailToCustomerSelected = false;
	customerEmail = '';
	customerName = '';

	dataClient = new FormGroup({
		firstName: new FormControl(''),
		lastName: new FormControl(''),
		primaryEmail: new FormControl(''),
		mobilPhone: new FormControl(''),
		source: new FormControl(''),
		companyName: new FormControl(''),
		accountAssociated: new FormControl(''),
		address: new FormControl(''),
		City: new FormControl(''),
		State: new FormControl(''),
		zipCode: new FormControl(''),
		alias: new FormControl(''),
		Email2: new FormControl(''),
		Email3: new FormControl(''),
		phoneHome: new FormControl(''),
		phoneWork: new FormControl(''),
		phoneOther: new FormControl(''),
		plan: new FormControl('')
	});

	singleUserData = new FormGroup({
		firstName: new FormControl(null, Validators.required),
		lastName: new FormControl(null, Validators.required),
		primaryEmail: new FormControl(null, [Validators.required, Validators.email]),
		mobilPhone: new FormControl(''),
		source: new FormControl('T3direct Marketing'),
		companyName: new FormControl(''),
		accountAssociated: new FormControl(''),
		address: new FormControl(''),
		city: new FormControl(''),
		state: new FormControl(''),
		zipCode: new FormControl(''),
		alias: new FormControl(null, Validators.required),
		email2: new FormControl(''),
		email3: new FormControl(''),
		phoneHome: new FormControl(''),
		phoneWork: new FormControl(''),
		phoneOther: new FormControl(''),
		userType: new FormControl(1)
	});

	dataCustomerType = new FormGroup({
		customerType: new FormControl(''),
	});

	dataContract = new FormGroup({
		startDate: new FormControl(''),
		endDate: new FormControl(''),
		costPerLead: new FormControl(''),
		leadMonth: new FormControl(''),
		numContract: new FormControl(''),
		isReserve: new FormControl(false),
		isHourly: new FormControl(false),
		leadNotes: new FormControl(''),
		checkType: new FormControl(false),
		timeZone: new FormControl('AST'),
		industry: new FormControl('0'),
		checkType1: new FormControl(false),
		checkType2: new FormControl(false),
		checkType3: new FormControl(false),
	});

	title_contract = 'INFORMATION CONTRACT';

	dataContractCampaign = new FormGroup({
		contract_sel: new FormControl(''),
		alias: new FormControl(''),
		campaing_sel: new FormControl(''),
	});

	dataDocuments = new FormGroup({
		contract_sel: new FormControl('0'),
	});

	dataOrder = new FormGroup({
		contract_sel: new FormControl('0'),
		campaing_sel: new FormControl('0'),
		leadTotal: new FormControl('0'),
		hoursTotal: new FormControl('0'),
	});
	dateOrderStatus = dayjs(new Date());
	dataOrderStatus = new FormGroup({
		status_order: new FormControl('0'),
		startDateTime: new FormControl(this.dateOrderStatus),
	});

	//table
	rowsClients: any = [];
	rowsClientsCustomer: any = [];
	rowsCampaignsContract: any = [];
	rowsDefaultWeek: any = [];
	rowsContracts: any = [];
	rowsOrders: any = [];
	activeContracts: any = [];
	editing: any = {};
	rowsDocs: any = [];

	allcontracts: any = [];

	//orders
	campaign_contract_: any = [];
	type_orders_: any = [];
	order_status: any = [];
	order_status_condition: any = [];

	//field search


	//information client review implement interface a class
	clientData: Client = {
		firstName: '',
		lastName: '',
		companyName: '',
		mobilPhone: '',
		primaryEmail: '',
		City: '',
		State: '',
		accountAssociated: '',
		address: '',
		source: 'T3direct Marketing',
		zipCode: '',
		password: null,
		alias: '',
		Email2: '',
		Email3: '',
		phoneHome: '',
		phoneWork: '',
		phoneOther: '',
		idUser: 0,
		plan: ''
	};
	customerType: CustomerType = {
		DescriptioncustomerType: '',
		isActive: 1,
		idCustomerType: 0,
		idUser: 0,
	};
	contractClient: Contract = {
		idContract: 0,
		startDate: new Date(),
		endDate: new Date(),
		leadsMonth: 0,
		costLead: 0,
		userid: 0,
		isActive: 1,
		leadsReserve: 0,
		type: 0,
		timeZone: '',
		industry: 0,
		notes: '',
		contractTypes: [],
	};
	campaignsClient: ContractsCampaigns = {
		idContractsCampaigs: 0,
		contractid: 0,
		alias: '',
		campaignid: 0,
		userid: 0,
		contractid_ini: 0,
	};
	Order: Order = {
		idOrder: 0,
		contractId: 0,
		campaignid: 0,
		total_leads: 0,
		total_hours: 0,
		start_date: new Date(),
		endDate: new Date(),
		statusOrder: 0,
		paid: false,
		transaction_details: null,
		idUser: 0,
		userCreation: 0,
	};
	columns: any;
	reorderable: any;


	// Form Add/Edit Clients Variables
	saveOnlyUserLoading = false;
	addOrEdit = 'add'

	loadingEmail = false;


	constructor(
		public authenticationService: AuthenticationService,
		private modalService: NgbModal,
		// @Inject(APP_CONFIG) private config: AppConfig,
		private dataService: OldDataService,
		private contractSrv: ContractsService,
		private ordersService: OrdersService,
		private userSrv: UserService,
		private campaignSrv: CampaignService,
		private utilsEndpointsSrv: UtilsEndPoints,
		public utils: UtilsService,
		private router: Router,
	) {
		// this.user = authenticationService.currentUserValue;
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
	}

	ngOnInit(): void {
		this.getClientUsers(1);
		this.getEmployeeUsers();
		this.getTypes();
		this.dataContract.controls['numContract'].disable();
		this.dataContract.controls['leadNotes'].disable();
		this.dataContractCampaign.controls['alias'].disable();
	}

	openEditUser(user_id) {
		// const modalRef = this.modalService.open(EditClientComponent, {
		// 	size: 'xl',
		// 	centered: true,
		// 	scrollable: true,
		// 	backdrop: 'static',
		// });

		// modalRef.componentInstance.user_id = user_id;

		this.router.navigate([`edit-client/${user_id}`]);
	}

	openModal(content){
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg'}).result.then(
			(result) => {
				console.info(result)
			},
			(reason) => {
				console.info(reason)
			},
		);
	}

	sendEmailToCustomer(){

		if(this.customerName == '' || this.customerEmail == ''){
			Swal.fire({
				icon: 'error',
				text: 'Please fill all the fieldsgit ',
				showCancelButton: false,
				confirmButtonText: 'Ok',
			});
			return;
		}
		const payload = {
			name: this.customerName,
			email: this.customerEmail
		}
		this.loadingEmail = true;
		this.userSrv.sendCreateUserEmailToCustomer(payload).subscribe((data: any)=>{
			Swal.fire({
				icon: 'success',
				title: 'Email sent correctly',
				showCancelButton: false,
				confirmButtonText: 'Ok',
			});
			this.loadingEmail = false;
			this.customerName = '';
			this.customerEmail = '';
			this.emailToCustomerSelected = false;
			this.modalService.dismissAll();
		});
	}

	updateFilter(event: any) {
		const val = event.target.value.toLowerCase();
		let answer_filter_alias: any[] = [];
		let answer_filter_login: any[] = [];
		let answer_filter_company_name: any[] = [];
		let answer_filter_name: any[] = [];
		let searchWithFilters: any[];

		if (val != '') {
			searchWithFilters = this.rowsClients;
		} else {
			searchWithFilters = this.SearchFilters;
		}

		answer_filter_alias = searchWithFilters.filter(function (d) {
			return d.alias.toLowerCase().indexOf(val) !== -1 || !val;
		});

		answer_filter_login = searchWithFilters.filter(function (d) {
			return d.login.toLowerCase().indexOf(val) !== -1 || !val;
		});

		answer_filter_company_name = searchWithFilters.filter(function (d) {
			if (d.company_name != null) {
				return d.company_name.toLowerCase().indexOf(val) !== -1 || !val;
			} else {
				return null;
			}
		});

		answer_filter_name = searchWithFilters.filter(function (d) {
			return d.name.toLowerCase().indexOf(val) !== -1 || !val;
		});

		const mergedFilters = [
			...answer_filter_alias,
			...answer_filter_login,
			...answer_filter_company_name,
			...answer_filter_name
		];

		const seenAliases = new Set();
		const answer_filter = mergedFilters.filter(item => {
			if (!seenAliases.has(item.alias)) {
				seenAliases.add(item.alias);
				return true;
			}
			return false;
		});

		this.rowsClients = answer_filter;
	}

	cleanFiltersSearch() {
		this.alias.nativeElement.value = '';
		this.login.nativeElement.value = '';
		this.company.nativeElement.value = '';
		this.prospect.nativeElement.value = '';
		this.campaign.nativeElement.value = '';

		if (this.filterClient == 'Active') {
			this.getClientUsers(1);
		} else {
			this.getClientUsers(0);
		}
	}

	getClientUsers(status: number) {
		this.loading = true;
		this.rowsClients = null;

		this.userSrv.getClientUserStatus(status).subscribe((data: any) => {
			this.rowsClients = data.body;
			this.loading = false;
			this.SearchFilters = this.rowsClients;
			if (status === 1) {
				this.filterClient = 'Active';
			} else {
				this.filterClient = 'Inactive';
			}
			this.loading = false;
			this.temp = [...this.rowsClients];
		});
	}

	deactivateUserConfirm(user: any) {
		Swal.fire({
			title: 'Deactivate ' + user.first + ' ' + user.last + ' ?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.deactivateUser(user);
			}
		});
	}

	deactivateUser(user: any) {
		this.loading = true;
		this.userSrv.deactivateUser(user.id).subscribe((data: any) => {
			Swal.fire('This user is not active anymore');
			this.getClientUsers(1);
			this.loading = false;
		});
	}

	activateUserConfirm(user: any) {
		Swal.fire({
			title: 'Activate ' + user.first + ' ' + user.last + ' ?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.activateUser(user);
			}
		});
	}

	activateUser(user: any) {
		this.loading = true;
		this.userSrv.activateUser(user.id).subscribe((data: any) => {
			Swal.fire('Correctly activated user');
			this.getClientUsers(0);
			this.loading = false;
		});
	}




	getCellClassLogin({ row, column, value }: { row: any; column: any; value: any }): any {
		return {
			' back-cell-gray content-point ': row['isActive'] == 0,
			' back-cell-blue content-point ': row['isActive'] == 1,
		};
	}

	getUserPass(last: string | String) {
		let str: any;
		let pass: any;

		if (last.length > 4) {
			str = last.substring(0, 4);
		} else if (last.length <= 4) {
			str = last;
		}

		pass = str.replace(/./g, (x: { charCodeAt: () => number }) => '22233344455566677778889999'[(x.charCodeAt() - 65) % 32] || x);

		if (pass.length === 4) {
			return pass;
		} else if (pass.length === 3) {
			return '0' + pass;
		} else if (pass.length === 2) {
			return '00' + pass;
		} else if (pass.length === 1) {
			return '000' + pass;
		}
	}

	testClientEmail(email1: any, email2: any, email3: any) {
		const payload = { email1: email1, email2: email2, email3: email3 };
		this.userSrv.testEmail(payload).subscribe((data: any) => {
			Swal.fire({
				title: 'Success',
				text: 'Test Email Sended!',
				confirmButtonText: 'Ok',
			});
		});
	}

	sendLinkToCustomer(user: any) {
		Swal.fire({
			title: 'Sending',
			text: 'Sending email reset password',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.userSrv.sendLinkCreationCustomer(`https://app.lmsleads.com/#/auth/signup/cover/${user.email1}`, user.email1).subscribe(
					(data: any) => {
						this.modalService.dismissAll();
						Swal.close();
						Swal.fire({
							title: 'Success',
							text: 'Link is sended correctly',
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
					},
					(error) => {
						Swal.fire({
							title: 'Error',
							icon: 'error',
							text: error,
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
					}
				);
			},
		});
	}

	//Save process
	public getEmployeeUsers() {
		this.employeeUsers = [];

		this.userSrv.getActiveEmployees().subscribe((data: any) => {
			// TODO: MANAGE REsponse
			if (data.body) {
				if (data.body && data.body.length && !data.error) {
					this.employeeUsers = data.body;
				} else if (!data.success) {
					this.employeeUsers = [];
				}
			} else {
				this.employeeUsers = [];
			}
		});
	}

	clearDataCient() {
		if (this.client_id === 0) {
			this.dataClient.reset();
		} else {
			this.getClientInfoId();
		}
	}

	getClientInfoId() {
		if (this.client_id > 0) {
			this.userSrv.getUserById(this.client_id).subscribe((data: any) => {
				const user = data.body;
				//fill data in each controls
				this.dataClient.controls['firstName'].setValue(user.first);
				this.dataClient.controls['lastName'].setValue(user.last);
				this.dataClient.controls['primaryEmail'].setValue(user.email1);
				this.dataClient.controls['mobilPhone'].setValue(user.phone_mobile);
				this.dataClient.controls['source'].setValue(user.source);
				this.dataClient.controls['companyName'].setValue(user.company_name);
				this.dataClient.controls['accountAssociated'].setValue(user.account_associated);
				this.dataClient.controls['address'].setValue(user.address);
				this.dataClient.controls['City'].setValue(user.city);
				this.dataClient.controls['State'].setValue(user.state);
				this.dataClient.controls['zipCode'].setValue(user.zip_code);
				this.dataClient.controls['alias'].setValue(user.alias);
				this.dataClient.controls['Email2'].setValue(user.email2);
				this.dataClient.controls['Email3'].setValue(user.email3);
				this.dataClient.controls['phoneHome'].setValue(user.phone_home);
				this.dataClient.controls['phoneWork'].setValue(user.phone_work);
				this.dataClient.controls['phoneOther'].setValue(user.phone_other);
				this.dataClient.controls['plan'].setValue(user.plan);

				this.dataContractCampaign.controls['alias'].setValue(user.alias);
				this.name_customer = `${user.first} ${user.last}`;
			});
		}
	}

	saveDataCustomerType() {
		if (this.client_id > 0) {
			if (this.ValidateDataCustomer()) {
				//fill data
				this.customerType.DescriptioncustomerType = this.dataCustomerType.controls['customerType'].value;
				this.customerType.idUser = this.client_id;

				if (this.customer_id > 0) {
					this.customerType.idCustomerType = this.customer_id;
				}
				const payload = this.customerType;

				this.userSrv.addCustomerType(payload).subscribe((data: any) => {
					this.clearDataCustomer();

					this.getCustomersTypebyClient();
					Swal.fire({
						title: 'Success',
						text: 'Data Saved!',

						confirmButtonText: 'Ok',
					});
				});
			} else {
				Swal.fire({
					title: 'Message',
					text: 'Please write something on customer type.',

					showCancelButton: false,
					confirmButtonText: 'Yes',
					cancelButtonText: 'Cancel',
				});
			}
		} else {
			Swal.fire({
				title: 'Message',
				text: 'Please fill all the information on tab CLIENT DATA and save.',

				showCancelButton: false,
				confirmButtonText: 'Yes',
				cancelButtonText: 'Cancel',
			});
		}
	}

	getCustomersTypebyClient() {
		if (this.client_id > 0) {
			this.rowsClientsCustomer = null;
			this.userSrv.getCustomersByClient(this.client_id).subscribe((data:any)=>{
				this.rowsClientsCustomer = data.body;
			});
		}
	}

	ValidateDataCustomer() {
		let respuesta: boolean = true;
		let msgValidation: string = '';
		if (this.dataCustomerType.controls['customerType'].value == '') {
			respuesta = false;
			msgValidation += ' Review the customer type.';
		}
		return respuesta;
	}

	getEditionCustomer(customerType: { idCustomer: number; DescriptionCustomer: any }) {
		this.customer_id = customerType.idCustomer;
		this.dataCustomerType.controls['customerType'].setValue(customerType.DescriptionCustomer);
	}

	setInactiveCustomer(customerType: { idCustomer: number }) {
		Swal.fire({
			title: 'Delete',
			text: 'ARE YOU SURE DELETE?.',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.customer_id = customerType.idCustomer;
				this.userSrv.deactivateCustomer(this.customer_id).subscribe((data: any) => {
					this.customer_id = 0;
						this.getCustomersTypebyClient();

						Swal.fire({
							title: 'Message',
							text: 'Row deleted!',

							confirmButtonText: 'Ok',
						});
				});
			}
		});
	}

	clearDataCustomer() {
		this.dataCustomerType.reset();
		this.customer_id = 0;
		this.customerType.idCustomerType = 0;
	}

	saveDataContract() {
		this.contractLoading = true;
		if (this.client_id > 0) {
			if (this.ValidateDataContract()) {
				//fill data
				this.contractClient.startDate = this.dataContract.controls['startDate'].value;
				this.contractClient.endDate = this.dataContract.controls['endDate'].value;
				this.contractClient.costLead = this.dataContract.controls['costPerLead'].value;

				this.contractClient.leadsMonth = this.dataContract.controls['leadMonth'].value;
				this.contractClient.userid = this.client_id;
				this.contractClient.leadsReserve = 0;
				this.contractClient.timeZone = this.dataContract.controls['timeZone'].value;
				this.contractClient.industry = this.dataContract.controls['industry'].value;
				this.contractClient.notes = this.dataContract.controls['leadNotes'].value;

				if (this.dataContract.value.isReserve) {
					this.contractClient.type = 1;
				}
				if (this.dataContract.value.isHourly) {
					this.contractClient.type = 3;
				}

				if (this.contractClient.type == 0) {
					this.contractClient.type = 4;
				}

				if (this.contract_id > 0) {
					this.contractClient.idContract = this.contract_id;
				}
				// UPDATE OR INSERT

				if (!this.updateContract) {

					const payload = { ... this.contractClient, contractTypes: this.typesSelected};

					this.userSrv.addContractClient(payload).subscribe((data: any) => {
						this.getAllContracts();
						this.getContractsXClient();
						this.getContractsCampaigns();
						this.getCampaigns();
						this.clearDataContract();

						Swal.fire({
							title: 'Success',
							text: 'Data Saved!',

							confirmButtonText: 'Ok',
						});
						this.contractLoading = false;
					});
				} else {
					this.contractClient.idContract = this.dataContract.controls['numContract'].value;
					this.contractSrv.updateContract(this.contractClient, this.typesSelected).subscribe((data) => {
						this.getAllContracts();
						this.getContractsXClient();
						this.getContractsCampaigns();
						this.getCampaigns();
						Swal.fire({
							title: 'Success',
							text: 'Contract updated, correctly.',
							icon: 'success',
							showCancelButton: false,
							confirmButtonText: 'OK',
						});
						this.contractLoading = false;
					});
				}
			} else {
				this.contractLoading = false;
				Swal.fire({
					title: 'Message',
					text: 'Please fill input cost per lead and leads per month, select a time zone and industry. If you select is reserve or hourly please write some comments.',

					showCancelButton: false,
					confirmButtonText: 'Yes',
					cancelButtonText: 'Cancel',
				});
			}
		} else {
			this.contractLoading = false;
			Swal.fire({
				title: 'Message',
				text: 'Please fill all the information on tab CLIENT DATA and save.',

				showCancelButton: false,
				confirmButtonText: 'Yes',
				cancelButtonText: 'Cancel',
			});
		}

		this.typesSelected = [];
		// this.dataContract.reset();
		// this.dataContract.controls['leadNotes'].disable();
	}

	clearDataContract() {
		this.dataContract.reset();
		this.contract_id = 0;
		this.typesSelected = [];
		this.dataContract.controls['timeZone'].setValue('AST');
		this.dataContract.controls['industry'].setValue('0');
		this.dataContract.controls['leadNotes'].disable();
		this.dataContract.controls['isReserve'].enable();
		this.dataContract.controls['isHourly'].enable();
		this.updateContract = false;
	}

	ValidateDataContract() {
		let respuesta: boolean = true;
		let msgValidation: string = '';
		if (this.dataContract.controls['costPerLead'].value === '' || this.dataContract.controls['costPerLead'].value === '0' || this.dataContract.controls['costPerLead'].value === null || this.dataContract.controls['costPerLead'].value === undefined) {
			respuesta = false;
			msgValidation += ' Review the costPerLead.';
		}

		if (this.dataContract.value.isReserve == undefined && this.dataContract.value.isHourly == undefined) {
			if (this.dataContract.controls['leadMonth'].value == '' || this.dataContract.controls['leadMonth'].value == '0' || this.dataContract.controls['leadMonth'].value === null || this.dataContract.controls['leadMonth'].value === undefined) {
				respuesta = false;
				msgValidation += ' Review the lead month.';
			}
		} else {
			if (this.dataContract.controls['leadMonth'].value == '' || this.dataContract.controls['leadMonth'].value === null || this.dataContract.controls['leadMonth'].value === undefined) {
				this.dataContract.controls['leadMonth'].setValue(0);
			}
		}

		if (this.dataContract.value.isReserve || this.dataContract.value.isHourly) {
			if (this.dataContract.controls['leadNotes'].value == '' || this.dataContract.controls['leadNotes'].value == '0' || this.dataContract.controls['leadNotes'].value === null || this.dataContract.controls['leadNotes'].value === undefined) {
				respuesta = false;
				msgValidation += ' Write some on notes.';
			}
			// else{
			// 	if (this.dataContract.controls['leadNotes'].value.length>3){
			// 		respuesta=false;
			// 		msgValidation+=" Write a message with 3 or mor characteres.";
			// 	}
			// }
		}
		if (this.dataContract.controls['timeZone'].value === '' || this.dataContract.controls['timeZone'].value === '0' || this.dataContract.controls['timeZone'].value === null || this.dataContract.controls['timeZone'].value === undefined) {
			respuesta = false;
			msgValidation += ' Review the timeZone.';
		}
		if (this.dataContract.controls['industry'].value == '' || this.dataContract.controls['industry'].value == '0' || this.dataContract.controls['industry'].value === null || this.dataContract.controls['industry'].value === undefined) {
			respuesta = false;
			msgValidation += ' Review the industry.';
		}

		return respuesta;
	}

	getContractsXClient() {
		if (this.client_id > 0) {
			this.userSrv.getClientContracts(this.client_id).subscribe((data: any) => {
				this.rowsContracts = data.body;
				this.activeContracts = this.rowsContracts.filter((contract: any) => contract.isActivate === 'YES');
			});
		}
	}

	getAllContracts() {
		if (this.client_id > 0) {
			this.contractSrv.getAllContracts().subscribe((data: any) => {
				if (!data.hasOwnProperty('error')) {
					if (data.body.length > 0) {
						this.allcontracts = data.body;
					} else {
						this.allcontracts = [];
					}
				} else {
					this.allcontracts = [];
				}
			});
		}
	}

	getCampaigns() {
		this.campaigns = [];
		this.campaignSrv.getCampaignsForSelect().subscribe((data: any) => {
			this.campaigns = data.body;
		});
	}

	saveContractCampaign() {
		if (this.client_id > 0) {
			if (this.ValidateCampaingContract()) {
				//fill data
				this.campaignsClient.contractid = this.dataContractCampaign.controls['contract_sel'].value;
				this.campaignsClient.alias = this.dataContractCampaign.controls['alias'].value;
				this.campaignsClient.campaignid = this.dataContractCampaign.controls['campaing_sel'].value;
				this.campaignsClient.userid = this.client_id;

				if (this.campaign_contractid > 0) {
					this.campaignsClient.idContractsCampaigs = this.campaign_contractid;
				}

				this.contractSrv.addContractToCampaign(this.campaignsClient).subscribe((data: any)=>{
					this.dataContractCampaign.controls['campaing_sel'].setValue('');
					this.dataContractCampaign.controls['contract_sel'].setValue('');
					this.getContractsCampaigns();

					Swal.fire({
						title: 'Success',
						text: 'Data Saved!',
						confirmButtonText: 'Ok',
					});
					this.clearContractCampaign();
				});
			} else {
				Swal.fire({
					title: 'Message',
					text: 'Please fill input Number contract, alias and select a campaign!',

					showCancelButton: false,
					confirmButtonText: 'Yes',
					cancelButtonText: 'Cancel',
				});
			}
		} else {
			Swal.fire({
				title: 'Message',
				text: 'Please fill all the information on tab CLIENT DATA and save.',

				showCancelButton: false,
				confirmButtonText: 'Yes',
				cancelButtonText: 'Cancel',
			});
		}
	}

	getContractsCampaigns() {
		if (this.client_id > 0) {
			this.rowsCampaignsContract = null;
			this.contractSrv.getContractsCampaignClient(this.client_id).subscribe((data: any)=>{
				this.rowsCampaignsContract = data.body;
			});
		}
	}

	clearContractCampaign() {
		this.campaign_contractid = 0;
		this.campaignsClient.idContractsCampaigs = 0;
		this.dataContractCampaign.controls['campaing_sel'].setValue('');

		this.getClientInfoId();
	}

	ValidateCampaingContract() {
		let respuesta: boolean = true;
		let msgValidation: string = '';
		if (this.dataContractCampaign.controls['contract_sel'].value === '' || this.dataContractCampaign.controls['contract_sel'].value === null || this.dataContractCampaign.controls['contract_sel'].value === undefined) {
			respuesta = false;
			msgValidation += ' Review the number contract.';
		}
		if (this.dataContractCampaign.controls['alias'].value === '' || this.dataContractCampaign.controls['alias'].value === null || this.dataContractCampaign.controls['alias'].value === undefined) {
			respuesta = false;
			msgValidation += ' Review the alias';
		}
		if (this.dataContractCampaign.controls['campaing_sel'].value == '' || this.dataContractCampaign.controls['campaing_sel'].value == '0') {
			respuesta = false;
			msgValidation += ' Review the campaign';
		}
		return respuesta;
	}

	getEditionCampaignContract(contractsCampaigns: { idRelation: number; campaignid: any; contractid: any }) {
		this.campaign_contractid = contractsCampaigns.idRelation;
		this.dataContractCampaign.controls['campaing_sel'].setValue(contractsCampaigns.campaignid);
		this.dataContractCampaign.controls['contract_sel'].setValue(contractsCampaigns.contractid);
	}

	setInactiveCampaignContract(contractsCampaigns: { idRelation: number }) {
		Swal.fire({
			title: 'Delete',
			text: 'Are you sure delete this relation?.',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.campaign_contractid = contractsCampaigns.idRelation;
				this.contractSrv.deactivateCampaignContract(this.campaign_contractid).subscribe((data: any)=>{
					this.campaign_contractid = 0;
					this.getContractsCampaigns();
					Swal.fire({
						title: 'Message',
						text: 'Row deleted!',
						confirmButtonText: 'Ok',
					});
				});
			}
		});
	}

	onChangeIsReserve(event: any) {
		if (event.target.checked) {
			this.dataContract.controls['leadNotes'].enable();
		} else {
			this.dataContract.controls['leadNotes'].disable();
		}

		if (event.target.value == 1 && event.target.checked) {
			this.dataContract.controls['isHourly'].disable();
		}
		if (event.target.value == 1 && event.target.checked == false) {
			this.dataContract.controls['isHourly'].enable();
		}
		if (event.target.value == 3 && event.target.checked) {
			this.dataContract.controls['isReserve'].disable();
		}
		if (event.target.value == 3 && event.target.checked == false) {
			this.dataContract.controls['isReserve'].enable();
		}
	}

	getTypes() {
		this.types = [];
		this.utilsEndpointsSrv.getAllTypes().subscribe({
			next: (data: any) => {
				this.types = data.body;
			},
			error: (error: any) => {
				this.types = [];
			}
		});
	}

	onChangeType(event: any) {
		if (event.target.checked) {
			this.typesSelected.push(event.target.value);
		} else {
			var indice = this.typesSelected.indexOf(event.target.value);
			this.typesSelected.splice(indice, 1);
		}
	}

	setInactiveContract(contractData: { NumContract: any }) {
		Swal.fire({
			title: 'Deactivate',
			text: 'ARE YOU SURE DEACTIVATE?.',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.contractSrv.deactivateContract(contractData.NumContract).subscribe((data: any)=>{
					this.getContractsXClient();
					Swal.fire({
						title: 'Message',
						text: 'Row Deactivated!',
						confirmButtonText: 'Ok',
					});
				});
			}
		});
	}

	getClassContractActive({ row, column, value }: { row: any; column: any; value: any }): any {
		return {
			' back-cell-blue': row['isActivate'] === 'YES',
			' back-cell-gray': row['isActivate'] === 'NO',
		};
	}
	getEditionContract(row: { NumContract: number }) {
		if (this.client_id > 0) {
			this.contractSrv.getContract(this.client_id, row.NumContract).subscribe((data: any) => {
				if (!data.hasOwnProperty('error')) {
					if (data.body.records.length > 0) {
						this.dataContract.controls['startDate'].setValue(data.body.records[0].datestart);
						this.dataContract.controls['endDate'].setValue(data.body.records[0].datefinish);
						this.dataContract.controls['costPerLead'].setValue(data.body.records[0].costlead);
						this.dataContract.controls['leadMonth'].setValue(data.body.records[0].leadmonth);
						this.dataContract.controls['numContract'].setValue(data.body.records[0].contractid);

						this.dataContract.controls['leadNotes'].setValue(data.body.records[0].leadsReserve);
						this.dataContract.controls['timeZone'].setValue(data.body.records[0].timeZone);
						this.dataContract.controls['industry'].setValue(data.body.records[0].industry);
						this.dataContract.controls['leadNotes'].setValue(data.body.records[0].coments);
						// this.dataContract.controls['']

						if (data.body.recordstypes.length > 0) {
							var namecheck = '';
							data.body.recordstypes.forEach((element: { typeid: string }) => {
								namecheck = 'checkType' + element.typeid;
								this.dataContract.controls[namecheck].setValue(true);
							});
						}

						if (data.body.records[0].type == 1) {
							this.dataContract.controls['isReserve'].setValue(true);
							this.dataContract.controls['isHourly'].disable();
							this.dataContract.controls['isHourly'].setValue(false);

							this.dataContract.controls['leadNotes'].enable();
						}

						if (data.body.records[0].type == 3) {
							this.dataContract.controls['isHourly'].setValue(true);
							this.dataContract.controls['isReserve'].disable();
							this.dataContract.controls['isReserve'].setValue(false);

							this.dataContract.controls['leadNotes'].enable();
						}

						this.contract_id = data.body.records[0].contractid;
						this.title_contract = 'LOOK INFORMATION CONTRACT - ' + this.contract_id;
					} else {
						Swal.fire({
							title: 'Message',
							text: 'Review with support this issue!',

							showCancelButton: false,
							confirmButtonText: 'Yes',
							cancelButtonText: 'Cancel',
						});

						this.clearDataContract();
						//this.dataContract.controls['isReserve'].setValue(false);
						this.dataContractCampaign.reset();
					}
				} else {
					this.clearDataContract();
					//this.dataContract.controls['isReserve'].setValue(false);
					this.dataContractCampaign.reset();
				}
			});
		}
	}
	setUpLeadsWeeks(contractxrow: { isActivate: string; NumContract: string; total_month: any }) {
		if (contractxrow.isActivate === 'YES') {
			this.contractSrv.getLeadsWeekSorted(contractxrow.NumContract).subscribe((data: any)=>{
				let week_1: number = 0;
				let week_2: number = 0;
				let week_3: number = 0;
				let week_4: number = 0;

				data.body.records.forEach(function (value: { week: string; lead_week: number }) {
					if (value.week === '1') {
						week_1 = value.lead_week;
					}
					if (value.week === '2') {
						week_2 = value.lead_week;
					}
					if (value.week === '3') {
						week_3 = value.lead_week;
					}
					if (value.week === '4') {
						week_4 = value.lead_week;
					}
				});
				this.rowsDefaultWeek = [
					{
						numContract: contractxrow.NumContract,
						leadsMonth: contractxrow.total_month,
						week1: week_1,
						week2: week_2,
						week3: week_3,
						week4: week_4,
					},
				];
			})
		} else {
			Swal.fire({
				title: 'Message',
				text: 'The Number contract ' + contractxrow.NumContract + ' is not active.',

				showCancelButton: false,
				confirmButtonText: 'Yes',
				cancelButtonText: 'Cancel',
			});
		}
	}

	getClassNumberContract({ row, column, value }: { row: any; column: any; value: any }): any {
		return {
			' back-cell-blue': row['NumContract'] > 0,
		};
	}

	updateValue(event: any, cell: string, rowIndex: string) {
		let sumLeadsWeek: number = 0;

		sumLeadsWeek = parseInt(this.rowsDefaultWeek[rowIndex]['week1']) + parseInt(this.rowsDefaultWeek[rowIndex]['week2']) + parseInt(this.rowsDefaultWeek[rowIndex]['week3']) + parseInt(this.rowsDefaultWeek[rowIndex]['week4']);

		if (sumLeadsWeek + parseInt(event.target.value) <= parseInt(this.rowsDefaultWeek[rowIndex]['leadsMonth'])) {
			this.editing[rowIndex + '-' + cell] = false;
			this.rowsDefaultWeek[rowIndex][cell] = event.target.value;
			this.rowsDefaultWeek = [...this.rowsDefaultWeek];
			const payload = { dataLeadDefault: this.rowsDefaultWeek };
			this.contractSrv.addSortDefaultleads(payload).subscribe((data: any)=>{
				Swal.fire({
					title: 'Success',
					text: 'Data Saved!',
					confirmButtonText: 'Ok',
				});
			});
		} else {
			this.editing[rowIndex + '-' + cell] = false;
			this.rowsDefaultWeek[rowIndex][cell] = 0;
			this.rowsDefaultWeek = [...this.rowsDefaultWeek];
			Swal.fire({
				title: 'Message',
				text: 'The leads by month is complete.',

				showCancelButton: false,
				confirmButtonText: 'Yes',
				cancelButtonText: 'Cancel',
			});
		}
	}

	changeContract(event: any) {
		this.getListFiles(event.target.value);
	}

	getListFiles(contract_selected: any) {
		this.loading_docs = true;
		var contract_selected;
		if (this.client_id > 0) {
			this.contractSrv.getDocumentsByContract(contract_selected).subscribe((data: any) => {
				if (!data.hasOwnProperty('error')) {
					if (data.body.records.length > 0) {
						this.rowsDocs = data.records;
						this.loading_docs = false;
					} else {
						this.rowsDocs = [];
						this.loading_docs = false;
					}
				} else {
					this.rowsDocs = [];
					this.loading_docs = false;
				}
			});
		}
	}
	saveDocument() {
		this.loading_docs = true;
		if (this.client_id > 0) {
			if (this.ValidateUploadDocuments()) {
				// let response_save_files=[]
				// var index=0;
				// let lis_response_saveFiles=[];

				for (var file of this.files) {
					var msj = '';
					var id = 0;
					var error = '';

					let formData = new FormData();
					formData.append('documents', file);
					formData.append('contract', this.dataDocuments.controls['contract_sel'].value);
					formData.append('user', this.user.id.toString());
					formData.append('customer', this.client_id.toString());

					// response_save_files.push([{nameFile:file.name, msg:msj, error:error, id:id}]);

					this.contractSrv.uploadDocument(formData).subscribe(
						(resp) => {
							msj = '';
							this.getListFiles(this.dataDocuments.controls['contract_sel'].value);
						},
						(error) => {
							msj += error;
						}
					);
					// index=index+1;
				}

				this.loading_docs = false;
			} else {
				Swal.fire({
					title: 'Message',
					text: 'Please select some contract and select some file to upload!.',

					showCancelButton: false,
					confirmButtonText: 'Yes',
					cancelButtonText: 'Cancel',
				});
			}
		}
	}
	ValidateUploadDocuments() {
		let respuesta: boolean = true;
		let msgValidation: string = '';
		if (this.dataDocuments.controls['contract_sel'].value === '' || this.dataDocuments.controls['contract_sel'].value === '0' || this.dataDocuments.controls['contract_sel'].value === null || this.dataDocuments.controls['contract_sel'].value === undefined) {
			respuesta = false;
			msgValidation += ' Review the contract.';
		}
		if ((this.list_documents.length = 0)) {
			respuesta = false;
			msgValidation += ' Select some document with relation to the contract.';
		}

		return respuesta;
	}
	clearDocuments() {
		this.dataDocuments.reset();
		this.list_documents = [];
		this.dataDocuments = new FormGroup({
			contract_sel: new FormControl('0'),
		});
		this.rowsDocs = [];
	}
	handleFileSelect(evt: any) {
		this.files = evt.target.files; // FileList object
		for (var file of this.files) {
			// prints values: 10, 20, 30, 40
			this.list_documents.push(file.name);
		}
	}
	deleteFile(row: { idFile: number; url: string; nameFile: string }) {
		Swal.fire({
			title: 'Remove file',
			text: 'ARE YOU SURE DELETE FILE?.',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				const payload = {
					contractid: this.dataDocuments.controls['contract_sel'].value,
					fileid: row.idFile,
					path: row.url,
					name: row.nameFile,
				}
				this.contractSrv.deleteFile(payload).subscribe((data) => {
					this.getListFiles(this.dataDocuments.controls['contract_sel'].value);
				});
			}
		});
	}

	//orders
	onChangeContract(value: any) {
		if (this.client_id > 0) {
			this.contractSrv.getCampaignContract(value).subscribe((data: any)=>{
				this.campaign_contract_ = data.body;
			});
		}
	}

	getTypeOrders() {
		this.ordersService.getTypeOrders().subscribe((data: any) => {
			this.type_orders_ = data.body;
		});
	}
	clearOrder() {
		this.dataOrder.reset();
		this.order_id = 0;
	}
	saveOrder() {
		this.loading_orders = true;
		if (this.client_id > 0) {
			if (this.ValidateOrder()) {
				this.Order.idUser = this.client_id;
				this.Order.contractId = this.dataOrder.controls['contract_sel'].value;
				this.Order.campaignid = this.dataOrder.controls['campaing_sel'].value;
				this.Order.total_leads = this.dataOrder.controls['leadTotal'].value;
				this.Order.total_hours = this.dataOrder.controls['hoursTotal'].value;
				this.Order.userCreation = this.user.id;

				this.Order.paid = false;
				this.Order.transaction_details = null;
				this.ordersService.add_order(this.Order).subscribe((data: any) => {
					this.dataOrder.reset();
					this.dataOrderStatus.controls['startDateTime'].setValue(this.dateOrderStatus);
					this.getListOrder();
					this.getStatusOrder();
					this.loading_orders = false;
				});

				this.loading_orders = false;
			} else {
				Swal.fire({
					title: 'Message',
					text: 'Please review the follow points:' + ' \n* set a contract.',

					showCancelButton: false,
					confirmButtonText: 'Yes',
					cancelButtonText: 'Cancel',
				});
			}
		}
	}
	getListOrder() {
		if (this.client_id > 0) {
			this.loading_orders = true;
			this.ordersService.listCampaignOrders(this.client_id).subscribe((data: any) => {
				if (data.body.records.length > 0) {
					this.rowsOrders = data.records;
				} else {
					this.rowsOrders = [];
				}
				this.loading_orders = false;
			});
		} else {
			this.rowsOrders = [];
		}
	}
	getEditionOrder(row: { contractid: any; campaignid: any; leads: any; hours: any; idOrder: number }) {
		if (this.client_id > 0) {
			this.dataOrder.controls['contract_sel'].setValue(row.contractid);

			this.onChangeContract(row.contractid);
			this.dataOrder.controls['campaing_sel'].setValue(row.campaignid);

			this.dataOrder.controls['leadTotal'].setValue(row.leads);
			this.dataOrder.controls['hoursTotal'].setValue(row.hours);
			// this.dataOrder.controls['startDate'].setValue(row.startDate);
			// this.dataOrder.controls['endDate'].setValue(row.endDate);
			// this.dataOrder.controls['order_sel'].setValue(row.type_orderid);

			this.order_id = row.idOrder;
		}
	}
	setInactiveOrder(value: any) {
		Swal.fire({
			title: 'Deactivate',
			text: 'ARE YOU SURE DEACTIVATE?.',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.ordersService.deactivateOrder(value).subscribe((data: any) => {
					if (data.length > 0 && data[0] > 0) {
						this.getListOrder();

						Swal.fire({
							title: 'Message',
							text: 'Row Deactivated!',

							confirmButtonText: 'Ok',
						});
					} else {
						Swal.fire({
							title: 'Error',
							text: 'Detail on service.',

							showCancelButton: false,
							confirmButtonText: 'Yes',
							cancelButtonText: 'Cancel',
						});
					}
				});
			}
		});
	}
	ValidateOrder() {
		let respuesta: boolean = true;
		let msgValidation: string = '';
		if (this.dataOrder.controls['contract_sel'].value === '' || this.dataOrder.controls['contract_sel'].value === '0' || this.dataOrder.controls['contract_sel'].value === null || this.dataOrder.controls['contract_sel'].value === undefined) {
			respuesta = false;
			msgValidation += ' Select a contract.';
		}
		if (this.dataOrder.controls['campaing_sel'].value === '' || this.dataOrder.controls['campaing_sel'].value === '0' || this.dataOrder.controls['campaing_sel'].value === null || this.dataOrder.controls['campaing_sel'].value === undefined) {
			respuesta = false;
			msgValidation += ' Select a campaign.';
		}
		if (this.dataOrder.controls['leadTotal'].value === '' || this.dataOrder.controls['leadTotal'].value === '0' || this.dataOrder.controls['leadTotal'].value === null || this.dataOrder.controls['leadTotal'].value === undefined) {
			this.dataOrder.controls['leadTotal'].setValue(0);
			if (this.dataOrder.controls['leadTotal'].value === '0' && this.dataOrder.controls['hoursTotal'].value === '0') {
				respuesta = false;
			}
		}
		if (this.dataOrder.controls['hoursTotal'].value === '' || this.dataOrder.controls['hoursTotal'].value === '0' || this.dataOrder.controls['hoursTotal'].value === null || this.dataOrder.controls['hoursTotal'].value === undefined) {
			this.dataOrder.controls['hoursTotal'].setValue(0);
			if (this.dataOrder.controls['leadTotal'].value === '0' && this.dataOrder.controls['hoursTotal'].value === '0') {
				respuesta = false;
			}
		}
		// if (this.dataOrder.controls['startDate'].value==="" || this.dataOrder.controls['startDate'].value===null || this.dataOrder.controls['startDate'].value=== undefined) {
		// 	respuesta=false;
		// 	msgValidation+=" Set start date.";
		// }
		// if (this.dataOrder.controls['order_sel'].value==="" || this.dataOrder.controls['order_sel'].value==="0" || this.dataOrder.controls['order_sel'].value===null || this.dataOrder.controls['order_sel'].value=== undefined) {
		// 	respuesta=false;
		// 	msgValidation+=" Set type of order.";
		// }

		return respuesta;
	}
	getCellClassStatusLead({ row, column, value }: { row: any; column: any; value: any }): any {
		return {
			' back-cell-gray content-point ': row['status_orderid'] == 4,
			' back-cell-blue content-point ': row['status_orderid'] == 1,
			' back-cell-approved content-point ': row['status_orderid'] == 2,
			' back-cell-yellow content-point ': row['status_orderid'] == 3,
		};
	}
	getCellClassremaining({ row, column, value }: { row: any; column: any; value: any }): any {
		return {
			' back-cell-approved  ': row['leads'] - row['sumLeads'] > 0,
			' back-cell-red ': row['leads'] - row['sumLeads'] < 0,
		};
	}

	////orderstatus
	changeStatusLead(
		content: any,
		order: {
			idOrder: number;
			type_orderid: number;
			status_orderid: number;
			startDate: string | number | dayjs.Dayjs | Date | null | undefined;
		}
	) {
		this.order_id = order.idOrder;
		this.type_orderid = order.type_orderid;
		this.validateStatus(order.status_orderid);

		//validate data to start and before open modal
		this.dataOrderStatus.controls['status_order'].setValue(order.status_orderid);

		if (order.status_orderid == 2) {
			// let dateTime_Saved=new Date(order.startDate)
			this.appearDateTime = true;

			this.dataOrderStatus.controls['startDateTime'].setValue(dayjs(order.startDate));
			this.date_saved_order = dayjs(order.startDate);
		} else {
			this.appearDateTime = false;
		}

		this.modalService
			.open(content, {
				ariaLabelledBy: 'modal-basic-title',
				centered: true,
			})
			.result.then(
				(result) => {},
				(reason) => {
					this.dataOrderStatus.reset();
					this.order_id = 0;
				}
			);
	}

	validateStatus(status: any) {
		this.order_status_condition = this.order_status;
		let result = [];
		switch (parseInt(status)) {
			case 1:
				result = this.order_status_condition.filter((orderStatus: { idStatus: number }) => orderStatus.idStatus == 2 || orderStatus.idStatus == 5 || orderStatus.idStatus == 1);
				this.order_status_condition = result;
				break;
			case 2:
				result = this.order_status_condition.filter((orderStatus: { idStatus: number }) => orderStatus.idStatus == 2 || orderStatus.idStatus == 4 || orderStatus.idStatus == 5);
				this.order_status_condition = result;
				break;
			case 4:
				result = this.order_status_condition.filter((orderStatus: { idStatus: number }) => orderStatus.idStatus == 4 || orderStatus.idStatus == 5 || orderStatus.idStatus == 7);
				this.order_status_condition = result;
				break;
			case 5:
				result = this.order_status_condition.filter((orderStatus: { idStatus: number }) => orderStatus.idStatus == 5);
				this.order_status_condition = result;
				break;
			case 6:
				result = this.order_status_condition.filter((orderStatus: { idStatus: number }) => orderStatus.idStatus == 6 || orderStatus.idStatus == 5 || orderStatus.idStatus == 7);
				this.order_status_condition = result;
				break;
			case 7:
				result = this.order_status_condition.filter((orderStatus: { idStatus: number }) => orderStatus.idStatus == 6 || orderStatus.idStatus == 5 || orderStatus.idStatus == 7);
				this.order_status_condition = result;
				break;
			default:
				this.order_status_condition = this.order_status;
				break;
		}
	}

	getStatusOrder() {
		this.ordersService.getOrderStatus().subscribe((data: any) => {
			if (data.body.length > 0) {
				this.order_status = data.body;
				this.order_status_condition = this.order_status;
			} else {
				this.order_status = [];
				this.order_status_condition = [];
			}
		});
	}

	saveOrderStatus() {
		this.rowsOrders = [];
		if (this.client_id > 0) {
			if (this.order_id > 0) {
				let valid = true;
				let date_start: { format: (arg0: string) => string } | null = null;

				if (this.dataOrderStatus.controls['status_order'].value == 2) {
					date_start = this.dataOrderStatus.controls['startDateTime'].value;
					if (date_start == null) {
						valid = false;
						Swal.fire({
							title: 'Message',
							text: 'Please review the start date time',

							showCancelButton: false,
							confirmButtonText: 'Yes',
							cancelButtonText: 'Cancel',
						});
					} else {
						if (this.date_saved_order != undefined) {
							valid = false;
							if (date_start.format('YYYY-MM-DD HH:mm:ss') != this.date_saved_order.format('YYYY-MM-DD HH:mm:ss')) {
								Swal.fire({
									title: 'Change date time',
									text: 'ARE YOU SURE CHANGE DATE TIME?.',

									showCancelButton: true,
									confirmButtonText: 'Yes',
									cancelButtonText: 'Cancel',
								}).then((result) => {
									if (result.value) {
										valid = true;
										this.updateStatusOrder(valid, date_start, this.type_orderid);
									}
								});
							}
						} else {
							this.updateStatusOrder(valid, date_start, this.type_orderid);
						}
					}
				} else {
					this.updateStatusOrder(valid, date_start, this.type_orderid);
				}
			}
		}
	}
	onChangeStatusOrder(val: any) {
		if (val == 2) {
			this.appearDateTime = true;
		} else {
			this.appearDateTime = false;
		}
	}

	updateStatusOrder(valid: boolean, date_start: { format: (arg0: string) => string } | null, type: number) {
		if (valid) {
			let date: string = '';

			if (date_start != null) {
				date = date_start.format('YYYY-MM-DD HH:mm:ss');
			}

			this.ordersService.change_status_order(this.order_id, this.dataOrderStatus.controls['status_order'].value, date, this.client_id, this.user.id, type).subscribe((data: any) => {
					if (data.body.type == 'confirm') {
						Swal.fire({
							title: 'Message',
							text: data.body.message,

							showCancelButton: true,
							confirmButtonText: 'Yes',
							cancelButtonText: 'Cancel',
						}).then((result) => {
							if (result.value) {
								this.ordersService.change_status_order(this.order_id, 7, date, this.client_id, this.user.id, type); //overload open
								this.modalService.dismissAll();
								this.getListOrder();
							} else {
								this.ordersService.change_status_order(this.order_id, 6, date, this.client_id, this.user.id, type);
								this.modalService.dismissAll();
								this.getListOrder();
							}
						});
					} else {
						Swal.fire({
							title: 'Message',
							text: data.message,

							showCancelButton: false,
							confirmButtonText: 'Yes',
							cancelButtonText: 'Cancel',
						});

						this.modalService.dismissAll();
						this.getListOrder();
					}


				// this.activeModal.dismiss();
				// this.activeModal.close();
			});
		}
	}

	selectContract(event) {
		if (event.type === 'click') {
			this.contractLoading = true;
			this.contractSrv.getContractNew(event.row.NumContract).subscribe((data: any) => {
				this.dataContract.setValue({
					startDate: data.body.start_date.split(' ')[0],
					endDate: data.body.end_date.split(' ')[0],
					costPerLead: data.body.cost_lead,
					leadMonth: data.body.total_leads_period,
					numContract: data.body.id,
					isReserve: data.body.contract_type == '1' ? true : false,
					isHourly: data.body.isHourly == '3' ? true : false,
					leadNotes: data.body.notes,
					checkType: true,
					timeZone: data.body.zone,
					industry: data.body.industry,
					checkType1: false,
					checkType2: false,
					checkType3: false,
				});

				if (data.body.call_types != '' && data.body.call_types != null) {
					this.dataContract.controls['checkType1'].setValue(data.body.call_types.includes('1') ? true : false);
					this.dataContract.controls['checkType2'].setValue(data.body.call_types.includes('2') ? true : false);
					this.dataContract.controls['checkType3'].setValue(data.body.call_types.includes('3') ? true : false);
					this.typesSelected = data.body.call_types.split(',');
				}

				this.updateContract = true;
				this.contractLoading = false;
			});

			// this.dataContract.setValue({
			//     startDate: event.row.startDate,
			//     endDate: event.row.endDate,
			//     costPerLead: event.row.costLead,
			//     leadMonth: event.row.total_month,
			//     numContract: event.row.NumContract,
			//     isReserve: true,
			//     isHourly: false,
			//     leadNotes: 'Estos son algunos comentarios de plomo.',
			//     checkType: true,
			//     timeZone: 'EST',
			//     industry: '1',
			//     checkType1: false,
			//     checkType2: true,
			//     checkType3: false
			//   });
		}
	}

	openUserWizardModal(){
		this.modalService.dismissAll();
		const modalRef = this.modalService.open(UserWizardComponent, {
			size: 'lg',
			centered: true,
			scrollable: true,
			backdrop: 'static',
		});

		modalRef.result.then(
			(result) => {
				Swal.fire({
					icon: 'success',
					title: 'User created correctly',
					text: 'Do you want to create a contract for this user?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
				}).then((res) => {
					if (res.isConfirmed) {
						this.openContractWizardModal(result);
					}
				});
			},
			(reason) => {
				console.error('Modal dismissed with:', reason);
			}
		);
	}
	client_data = {
		id: 59,
		alias: 't3client001'}

	openContractWizardModal(client_data: any) {
		const modalRef = this.modalService.open(ContractWizardComponent, {
			size: 'lg',
			centered: true,
			scrollable: true,
			backdrop: 'static',
		});

		modalRef.componentInstance.client_data = client_data;


		modalRef.result.then(
			(result) => {
				Swal.fire({
					icon: 'success',
					title: 'Contract created correctly',
					text: 'Do you want to create the Campaign Now?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
				}).then((res) => {
					if (res.isConfirmed) {
						this.openCampaignWizardModal(result);
					}
				});
			},
			(reason) => {
				console.error('Modal dismissed with:', reason);
			}
		);
	}

	contract_data = {
		"success": true,
		"contract_id": "304",
		"user_id": 59,
		"contract_type": 1,
		"industry": "5",
		"pricing_description": "Lead Cost",
		"pricing_value": 200,
		"alias": "t3client001"
	}

	openCampaignWizardModal(contract_data: any) {
		const modalRef = this.modalService.open(CampaignWizardComponent, {
			size: 'lg',
			centered: true,
			scrollable: true,
			backdrop: 'static',
		});

		modalRef.componentInstance.contract_data = contract_data;

		modalRef.result.then(
			(result) => {
				Swal.fire({
					icon: 'success',
					title: 'Campaign created correctly',
					showCancelButton: false,
					confirmButtonText: 'Ok',

				});
			},
			(reason) => {
				console.info('Modal dismissed with:', reason);
			}
		);
	}

	// Functions for Form Add and Edit Clients

	saveDataClient() {
		const md5 = new Md5();

		this.loading = true;
		if (this.ValidateDataClient()) {

			if (this.client_id > 0) { // If is edition
				this.clientData.idUser = this.client_id;
				this.clientData.alias = this.dataClient.controls['alias'].value;
				this.clientData.Email2 = this.dataClient.controls['Email2'].value;
				this.clientData.Email3 = this.dataClient.controls['Email3'].value;
				this.clientData.phoneHome = this.dataClient.controls['phoneHome'].value;
				this.clientData.phoneWork = this.dataClient.controls['phoneWork'].value;
				this.clientData.phoneOther = this.dataClient.controls['phoneOther'].value;
			}

			this.clientData.firstName = this.dataClient.controls['firstName'].value;
			this.clientData.lastName = this.dataClient.controls['lastName'].value;
			this.clientData.primaryEmail = this.dataClient.controls['primaryEmail'].value;
			this.clientData.mobilPhone = this.dataClient.controls['mobilPhone'].value;
			this.clientData.source = this.dataClient.controls['source'].value;
			this.clientData.companyName = this.dataClient.controls['companyName'].value;
			this.clientData.accountAssociated = this.dataClient.controls['accountAssociated'].value;
			this.clientData.address = this.dataClient.controls['address'].value;
			this.clientData.City = this.dataClient.controls['City'].value;
			this.clientData.State = this.dataClient.controls['State'].value;
			this.clientData.zipCode = this.dataClient.controls['zipCode'].value;
			this.clientData.plan = this.dataClient.controls['plan'].value;

			const pass = md5.appendStr(this.getUserPass(this.clientData.lastName)).end();

			this.clientData.password = pass;
			this.userSrv.createCompleteUser(this.clientData).subscribe((data: any)=>{
				if (data.success) {
					this.client_id = data.body[0];
					this.getClientUsers(1);
					this.loading = false;

					if (this.client_id > 0) {
						this.dataClient.controls['alias'].enable();
						this.dataClient.controls['Email2'].enable();
						this.dataClient.controls['Email3'].enable();
						this.dataClient.controls['phoneHome'].enable();
						this.dataClient.controls['phoneWork'].enable();
						this.dataClient.controls['phoneOther'].enable();
						this.getClientInfoId();
					}

					Swal.fire({
						title: 'Success',
						text: 'Data Saved!',

						confirmButtonText: 'Ok',
					});
				} else {
					this.loading = false;
					Swal.fire({
						title: 'Error',
						text: 'Please fill all the information',

						showCancelButton: false,
						confirmButtonText: 'Yes',
						cancelButtonText: 'Cancel',
					});
				}
			})



		} else {
			this.loading = false;
			Swal.fire({
				title: 'Error',
				text: 'Please fill all the information',
				showCancelButton: false,
				confirmButtonText: 'Yes',
				cancelButtonText: 'Cancel',
			});
		}
	}

	ValidateDataClient() {
		let respuesta: boolean = true;
		let msgValidation: string = '';

		if (this.dataClient.controls['firstName'].value == '') {
			respuesta = false;
			msgValidation += ' Review the First Name';
		}

		if (this.dataClient.controls['lastName'].value == '') {
			respuesta = false;
			msgValidation += ' Review the Last Name';
		}

		if (this.dataClient.controls['primaryEmail'].value == '') {
			respuesta = false;
			msgValidation += ' Review the Primary Email';
		}

		if (this.dataClient.controls['mobilPhone'].value == '') {
			respuesta = false;
			msgValidation += ' Review the Mobil Phone';
		}

		if (this.dataClient.controls['source'].value == '') {
			respuesta = false;
			msgValidation += ' Review the source';
		}

		if (this.dataClient.controls['companyName'].value == '') {
			respuesta = false;
			msgValidation += ' Review the company name';
		}

		if (this.dataClient.controls['accountAssociated'].value == '') {
			respuesta = false;
			msgValidation += ' Review the account associated';
		}

		if (this.dataClient.controls['address'].value == '') {
			respuesta = false;
			msgValidation += ' Review the address';
		}

		if (this.dataClient.controls['City'].value == '') {
			respuesta = false;
			msgValidation += ' Review the City';
		}

		if (this.dataClient.controls['State'].value == '') {
			respuesta = false;
			msgValidation += ' Review the State';
		}

		if (this.dataClient.controls['zipCode'].value == '') {
			respuesta = false;
			msgValidation += ' Review the Zip Code';
		}

		return respuesta;

		//add class to resppuest for validating forms
	}

	updateFilter2(event, props: string) {
		const val = event.target.value.toLowerCase();
		const propArray = props.split(',');
		// filter our data
		const temp = this.temp.filter(function (d) {
			// Verifica si alguna de las propiedades contiene el valor buscado
			return propArray.some(prop => {
				return d[prop].toLowerCase().indexOf(val) !== -1 || !val;
			});
		});

		// update the rows
		this.rowsClients = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}


}
